import React, { FC } from "react"

import { PhaseContext } from "../../../utils/Interfaces"
import { FormComposer } from "../../../lib/engines/FormComposer";

export const DynamicPhaseHandler: FC<PhaseContext> = ({ phase, state, values, faults, listboxHandler, blurHandler, changeHandler }) => {

    /**
     * Lists the elements/attributes under a specific phase
     * 
     * @param {string} attrId - The 'g' ID of the top-level attribute object.
     * @param {Array} attributes - The specific state array to search within (e.g. state.data.attributes)
     * 
     * @returns {any | null} - The specific field definition or null.
     */
    const resolvePhaseAttributes = (attrId: string, attributes: any[]): any | null => {
        // Find the parent attribute block first
        return attributes.find((attr: any) => attr.g === attrId) || null;
    };

    const phaseElements = resolvePhaseAttributes(phase.gid, state.data.attributes)

    console.log('current', phase);
    console.log('phaseElements', phaseElements.s);

    return (
        <React.Fragment>
            <div className="w-full pb-8 text-base font-semibold text-stone-700 dark:text-slate-300 uppercase tracking-wide">
                {phase.title}

                <p className="text-stone-500 dark:text-stone-300 pt-1 text-sm normal-case tracking-normal font-normal">
                    {phase.caption}
                </p>
            </div>

            <ul className="w-full flex flex-col">
                {
                    phaseElements.s.map((element: any) => {
                        console.log('ELEMENTS', element)
                        

                        return element.n && (
                            <li key={element.g} className="text-sm w-full flex flex-col pt-2 pb-2">
                                <FormComposer 
                                phase={phase}
                                values={values}
                                faults={faults}
                                element={element} 
                                state={state} 
                                changeHandler={changeHandler} 
                                blurHandler={blurHandler} 
                                optionHandler={undefined} 
                                dateHandler={undefined} />
                            </li>
                        )
                    })
                }
            </ul>
        </React.Fragment>
    )
}